var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nrs-privacy-policy-page",attrs:{"id":"top"}},[_c('div',{staticClass:"body-wrapper"},[_c('HeaderSimple'),_c('PrivacyPolicy',{attrs:{"lang":"en-us"}}),_c('FooterSimple')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }